import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeSlug from "rehype-slug";
import { remarkAlert } from "remark-github-blockquote-alert";

/**
 * Trauma-informed article typography.
 *
 * - Larger, more generous prose scale for calm reading.
 * - Pull-quote styling on blockquotes.
 * - GitHub-style callouts via `> [!NOTE]`, `> [!TIP]`, `> [!IMPORTANT]`,
 *   `> [!WARNING]`, `> [!CAUTION]`.
 */
export function BlogMarkdown({ children }: { children: string }) {
  return (
    <div
      className="
        prose prose-neutral dark:prose-invert max-w-none
        prose-lg lg:prose-xl
        prose-headings:font-display prose-headings:font-semibold prose-headings:tracking-tight
        prose-h2:mt-14 prose-h2:mb-5 prose-h2:text-2xl sm:prose-h2:text-3xl
        prose-h3:mt-10 prose-h3:mb-3 prose-h3:text-xl sm:prose-h3:text-2xl
        prose-p:leading-[1.85] prose-p:my-5
        prose-li:leading-[1.8] prose-li:my-2
        prose-a:text-primary prose-a:font-medium prose-a:no-underline hover:prose-a:underline
        prose-strong:text-foreground
        prose-img:rounded-2xl prose-img:my-10 prose-img:shadow-sm
        prose-hr:my-14 prose-hr:border-border
        prose-blockquote:not-italic prose-blockquote:border-s-4 prose-blockquote:border-primary/60
        prose-blockquote:bg-primary/5 prose-blockquote:rounded-r-2xl
        prose-blockquote:px-6 prose-blockquote:py-5
        prose-blockquote:font-display prose-blockquote:text-xl sm:prose-blockquote:text-2xl
        prose-blockquote:text-foreground prose-blockquote:leading-snug
        prose-code:before:content-none prose-code:after:content-none
        prose-code:bg-muted prose-code:px-1.5 prose-code:py-0.5 prose-code:rounded
      "
    >
      <ReactMarkdown
        remarkPlugins={[remarkGfm, remarkAlert]}
        rehypePlugins={[rehypeSlug]}
        components={{
          // The page hero already renders the article's single <h1>.
          // Any `# Heading` inside the body is demoted to <h2> so each
          // article keeps exactly one top-level heading.
          h1: ({ node: _node, ...props }) => <h2 {...props} />,
        }}
      >
        {children}
      </ReactMarkdown>

    </div>
  );
}
